/*
    © 2022 KondaSoft.com
    https://www.kondasoft.com
*/

class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));

        document.querySelector('#offcanvas-search')?.addEventListener('shown.bs.offcanvas', () => {
            this.input.focus();
        });

        // Set up event delegation for form submission
        document.addEventListener('submit', (event) => {
            // Check if the form is part of the predictive search component
            if (event.target.closest('predictive-search')) {
                this.handleFormSubmit(event);
            }
        });
    }

    onChange() {
        const searchTerm = this.formatSearchTerm(this.input.value);

        console.log(searchTerm);

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm);
    }

    handleFormSubmit(event) {
        event.preventDefault();

        const searchTerm = this.formatSearchTerm(this.input.value);
        const searchUrl = `/search?q=${encodeURIComponent(searchTerm)}`;

        window.location.href = searchUrl;
    }

    formatSearchTerm(term) {
        let searchTerm = term.trim();
        searchTerm = searchTerm.replace(/^"|"$/g, '');
        return `"${searchTerm}"`;
    }

    async getSearchResults(searchTerm) {
        const response = await fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=10&section_id=predictive-search`);

        if (!response.ok) {
            const error = new Error(response.status);
            this.close();
            throw error;
        }

        const text = await response.text();
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
    }

    open() {
        this.predictiveSearchResults.style.display = 'block';
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        }
    }
}

customElements.define('predictive-search', PredictiveSearch);
